import { MdOutlineAccessTime } from 'react-icons/md'

import type { ReactElement, SyntheticEvent } from 'react'

import Input from '../../TextInput'

interface TimeInputProps {
  dateValue: Date | null
  onTimeChange: (time: string, date: Date | null) => void
  readOnly?: boolean
}

const TimeInput = ({ dateValue, onTimeChange, readOnly }: TimeInputProps): ReactElement => {
  /** Local state */

  const value = dateValue?.toLocaleTimeString('fr-FR') || '00:00:00'

  /** Handlers */

  const handleChange = (evt: SyntheticEvent<HTMLInputElement>) => onTimeChange(evt.currentTarget.value, dateValue)

  /** Render */

  return (
    <Input
      className="custom-time-input"
      icon={<MdOutlineAccessTime size={16} />}
      onChange={handleChange}
      readOnly={readOnly}
      role="textbox"
      size={'medium'}
      step="1"
      type="time"
      value={value}
    />
  )
}

export default TimeInput
